// import type { Components } from '@mui/material/styles';

export const CUSTOM_ATTRIBUTE_FLEX_WRAP = 'data-0';
export const CUSTOM_ATTRIBUTE_FULL_WIDTH = 'data-1';

export default function MUIStack() /* : Components['MuiStack'] */ {
  return {
    defaultProps: {
      useFlexGap: true,
    },
    variants: [
      {
        props: { [CUSTOM_ATTRIBUTE_FLEX_WRAP]: 'wrap' },
        style: {
          flexWrap: 'wrap',
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_FLEX_WRAP]: 'wrap-reverse' },
        style: {
          flexWrap: 'wrap-reverse',
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_FLEX_WRAP]: 'nowrap' },
        style: {
          flexWrap: 'nowrap',
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_FULL_WIDTH]: '' },
        style: {
          width: '100%',
        },
      },
    ],
  };
}
